// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContextMenu_context__QiRz7 {
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  border-radius: 4px;
  border: 1px solid #E8ECEE;
  background: #FFF;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.08);
  width: 188px;
  max-height: 70vh;
  overflow-y: auto;
}
.ContextMenu_context__QiRz7::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.ContextMenu_context__QiRz7 .icon-fill {
  --context-menu-icon-fill: #3D525C;
}
.ContextMenu_context__QiRz7 a,
.ContextMenu_context__QiRz7 button {
  display: flex;
  align-items: center;
  min-height: 34px;
  padding-left: 6px;
  padding-right: 3px;
  gap: 0 4px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 154%;
  color: var(--text-color);
  border: none;
  background: #fff;
  transition: 0.2s;
  width: 100%;
  text-align: left;
}
.ContextMenu_context__QiRz7 a svg,
.ContextMenu_context__QiRz7 button svg {
  fill: var(--context-menu-icon-fill, none);
  flex-shrink: 0;
}
@media (hover: hover) {
  .ContextMenu_context__QiRz7 a:hover,
  .ContextMenu_context__QiRz7 button:hover {
    background: #F6F8F9;
  }
}
.ContextMenu_context__QiRz7 h1, .ContextMenu_context__QiRz7 h2, .ContextMenu_context__QiRz7 h3, .ContextMenu_context__QiRz7 h4, .ContextMenu_context__QiRz7 h5, .ContextMenu_context__QiRz7 h6 {
  padding: 4px 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/Assets/ContextMenu/ContextMenu.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,2CAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AACF;AACE;EACE,QAAA;EACA,SAAA;AACJ;AAGI;EACE,iCAAA;AADN;AAKE;;EAEE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAHJ;AAKI;;EACE,yCAAA;EACA,cAAA;AAFN;AAKI;EACE;;IACE,mBAAA;EAFN;AACF;AAME;EACE,gBAAA;AAJJ","sourcesContent":[".context {\r\n  position: fixed;\r\n  z-index: 3;\r\n  top: 0;\r\n  left: 0;\r\n  border-radius: 4px;\r\n  border: 1px solid #E8ECEE;\r\n  background: #FFF;\r\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.08);\r\n  width: 188px;\r\n  max-height: 70vh;\r\n  overflow-y: auto;\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 0;\r\n    height: 0;\r\n  }\r\n\r\n  :global {\r\n    .icon-fill {\r\n      --context-menu-icon-fill: #3D525C;\r\n    }\r\n  }\r\n\r\n  a,\r\n  button {\r\n    display: flex;\r\n    align-items: center;\r\n    min-height: 34px;\r\n    padding-left: 6px;\r\n    padding-right: 3px;\r\n    gap: 0 4px;\r\n    font-size: 12px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 154%;\r\n    color: var(--text-color);\r\n    border: none;\r\n    background: #fff;\r\n    transition: 0.2s;\r\n    width: 100%;\r\n    text-align: left;\r\n\r\n    svg {\r\n      fill: var(--context-menu-icon-fill, none);\r\n      flex-shrink: 0;\r\n    }\r\n\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        background: #F6F8F9;\r\n      }\r\n    }\r\n  }\r\n\r\n  h1, h2, h3, h4, h5, h6 {\r\n    padding: 4px 6px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"context": `ContextMenu_context__QiRz7`
};
export default ___CSS_LOADER_EXPORT___;
